// KYC reasons are written by the api, which prefixes each one with the status the document ends
// up in (see utils/documentUtils.js there). That prefix is the contract between the two repos:
// a prefix added on the api side and not handled here falls back to "unknown" and must never be
// mistaken for a validation.
const REASON_PREFIXES = [
  { prefix: '[OK]', outcome: 'validated' },
  { prefix: '[A VERIFIER]', outcome: 'pending' },
  { prefix: '[ECHEC]', outcome: 'rejected' },
];

// The social security number is appended to some reasons. It is fine in the document detail, but
// it has no place in a truncated badge label.
const SOCIAL_SECURITY_SUFFIX = /\s*-\s*N°\s*SS\s*:.*$/i;

/**
 * Reads the status an api-written KYC reason goes with, and the wording to display.
 * @param {string} reason - Raw reason stored on the document
 * @returns {{outcome: 'validated'|'pending'|'rejected'|'unknown', text: string}}
 */
export const parseKycReason = (reason) => {
  const raw = typeof reason === 'string' ? reason.trim() : '';
  if (!raw) return { outcome: 'unknown', text: '' };

  const matched = REASON_PREFIXES.find(({ prefix }) => raw.startsWith(prefix));
  const withoutPrefix = matched ? raw.slice(matched.prefix.length) : raw;

  return {
    outcome: matched ? matched.outcome : 'unknown',
    text: withoutPrefix.replace(SOCIAL_SECURITY_SUFFIX, '').trim(),
  };
};

export default parseKycReason;
